import Icon from '@/components/Icon/Icon';

const ChevronLeftIcon = ({fill = 'currentColor', ...rest}) => {
    return (
        <Icon width='24' height='24' {...rest}>
            <path d='M14.8979 4L7.12915 11.7419' stroke={fill} strokeWidth='1.5' strokeLinecap='round' />
            <path d='M7.12891 11.7419L14.8977 19.5107' stroke={fill} strokeWidth='1.5' strokeLinecap='round' />
        </Icon>
    );
};

export default ChevronLeftIcon;
